import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import FDialog from '@/components/common/FDialog.vue'
import FBtn from '@/components/common/FBtn.vue'
import FForm from '@/components/common/FForm.vue'
import FBadge from '@/components/common/FBadge.vue'
import FSelect from '@/components/common/FSelect.vue'
import FImage from '@/components/common/FImage.vue'
import FDateRangeField from '@/components/common/FDateRangeField.vue'
import FDatePicker from '@/components/common/FDatePicker.vue'

Vue.config.productionTip = false

// Custom components
Vue.component('f-dialog', FDialog)
Vue.component('f-badge', FBadge)
Vue.component('f-btn', FBtn)
Vue.component('f-form', FForm)
Vue.component('f-select', FSelect)
Vue.component('f-image', FImage)
Vue.component('f-date-range-field', FDateRangeField)
Vue.component('f-date-picker', FDatePicker)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
